<template>
    <div>
        <el-form :model="userForm" :rules="formRules" label-position="right" ref="userForm" label-width="100px" class="demo-ruleForm">
            <el-input v-model="userForm.userPid" type="hidden" style="width: 98%;"></el-input>
            <el-form-item label="用户姓名" prop="userName">
                <el-input ref="userNameEl" v-model="userData.userName" style="width: 98%" placeholder="输入用户姓名" ></el-input>
            </el-form-item>
            <el-form-item label="用户帐号" prop="userAccount">
                <el-input v-model="userForm.userAccount" :readonly="true" readonly style="width: 98%"></el-input>
            </el-form-item>
            <el-form-item label="用户帐号" prop="userAccount">
                <el-input v-model="userForm.userPassword" style="width: 98%" placeholder="请输入帐号密码"></el-input>
            </el-form-item>
        </el-form>
        <div style="text-align: center">
            <el-button type="primary" style="width: 120px" :disabled="saveButState" @click="submitForm()" v-html="saveButValue"></el-button>
            <el-button type="danger" style="width: 120px" @click="closeWindow()">关 闭</el-button>
        </div>
    </div>
</template>
<script>
    import {appjs} from "@/utiljs/apputil";
    export default {
        components: {
        },
        props: {
            userData:{
                type: Object
            },
            closeWindow: {
                type: Function
            }
        },
        data() {
            return {
                saveButValue: '更 新',
                saveButState: false,
                innerVisible:false,
                tableData:[],
                tableHeight: '280px',
                userForm: {
                    userPid: '',
                    userName: '',
                    userAccount: '',
                    userPassword:''
                },
                formRules: {
                    userPassword: [
                        { required: true, message: '请输入帐号密码', trigger: 'blur' }
                    ]
                }
            }
        },
        created() {
            this.userForm = this.userData;
        },
        methods:{
            resertForm() {
                this.saveButValue = '更 新';
                this.saveButState = false;
                this.userForm = this.userData;
            },
            submitForm() {

            }
        }
    }
</script>
